import * as React from "react"
const Adventure = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3.177}
      d="M6.212 36.044h31.767L25.765 10.256a4.06 4.06 0 0 0-7.339 0L6.212 36.044Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3.177}
      d="m14.153 20.16 3.53 4.412 4.412-4.412 3.53 5.294 4.412-3.53"
    />
  </svg>
)
export default Adventure